
// store.js
import { configureStore } from '@reduxjs/toolkit';

import categoriesReducer from '../reducers/categoriesSlice';
import userSlice from '../reducers/userSlice';
import userAdmin from '../reducers/userAdmin';
import produtoSlice from '../reducers/produtoSlice';
import modeloSlice from '../reducers/modeloSlice';
import vitrineSlice from '../reducers/vitrineSlice';
import cartReducer from '../reducers/cartSlice';
import vendasSlice from '../reducers/vendasSlice';
import blogSlice from '../reducers/blogSlice';
import proposalsReducer from '../reducers/propostaSlice'; 
import propostaUserSlice from '../reducers/propostaUserSlice'; 

const store = configureStore({
  reducer: {
    proposals: proposalsReducer,
    categories: categoriesReducer,
    user: userSlice,
    userAdmin: userAdmin,
    produtos: produtoSlice,
    modelos: modeloSlice,
    vitrini: vitrineSlice,
    cart: cartReducer,
    vendas: vendasSlice,
    blog: blogSlice,
    propostaUserSlice:propostaUserSlice

  },
});

export default store;
